module.exports = __webpack_public_path__ + "images/category_lp/home_appliance/new/assessment_achievements/4_c6607d6bbb5d88695e3af16a6ec41ff4.png";